import {
  POLICY_MAKER_WORKSPACE_ROUTES,
  policyMakerPageFeature,
  resolvePolicyMakerRouteId,
} from '../config/policyMakerNav';
import { isSuperAdminUser } from './userRoles';

function normalizeFeatures(features) {
  if (!Array.isArray(features)) return [];
  return features
    .map((f) => (typeof f === 'string' ? f.trim().toLowerCase() : ''))
    .filter(Boolean);
}

function enabledPolicyMakerRouteIds(features) {
  return new Set(
    normalizeFeatures(features)
      .filter((f) => f.startsWith('policy_maker:'))
      .map((f) => resolvePolicyMakerRouteId(f.slice('policy_maker:'.length))),
  );
}

export function formatPolicyMakerPageLabel(feature) {
  if (typeof feature !== 'string' || !feature.startsWith('policy_maker:')) {
    return feature || '';
  }
  const routeId = resolvePolicyMakerRouteId(feature.slice('policy_maker:'.length));
  const route = POLICY_MAKER_WORKSPACE_ROUTES.find((r) => r.id === routeId);
  return route?.label || routeId;
}

export function getVisiblePolicyMakerRoutes(features, user) {
  if (isSuperAdminUser(user)) {
    return POLICY_MAKER_WORKSPACE_ROUTES;
  }
  const enabled = enabledPolicyMakerRouteIds(features);
  if (enabled.size === 0) {
    return POLICY_MAKER_WORKSPACE_ROUTES;
  }
  return POLICY_MAKER_WORKSPACE_ROUTES.filter((r) => enabled.has(r.id));
}

export function isPolicyMakerRouteEnabled(routeId, features, user) {
  if (isSuperAdminUser(user)) return true;
  const enabled = normalizeFeatures(features).filter((f) => f.startsWith('policy_maker:'));
  if (enabled.length === 0) return true;
  const resolved = resolvePolicyMakerRouteId(routeId);
  return enabled.some(
    (f) => resolvePolicyMakerRouteId(f.slice('policy_maker:'.length)) === resolved,
  );
}

export function firstAccessiblePolicyMakerPath(features, user) {
  const routes = getVisiblePolicyMakerRoutes(features, user);
  return routes[0]?.path || '/policy-makers/alerts';
}
